import React from 'react';
import PropTypes from 'prop-types';
import ButtonEdit from '../ButtonEdit';
import View from './View';
import Edit from './Edit';
import { usStatePropType } from './StateField';

const Insured = ({
  edit,
  confirm,
  enabled,
  confirmed,
  insuredRenter,
  insuredFirstName,
  insuredLastName,
  insuredCompany,
  insuredCompanyType,
  jointVentureType,
  insuredAddress,
  insuredCity,
  insuredState,
  insuredZip,
  insuredCountry,
  valid,
  usStates,
  insuranceContactRef,
  scrollToPosition,
}) => (
  <div className={`component ${enabled ? 'enabled' : 'disabled'}`}>
    <div className="form-row justify-content-between">
      <div className="col-auto my-auto">
        <h3>Insured</h3>
      </div>
      <ButtonEdit edit={edit} show={confirmed} />
    </div>
    <div className="card">
      <div className="card-body">
        <Edit
          confirm={confirm}
          show={!confirmed}
          valid={valid}
          insuredRenter={insuredRenter}
          usStates={usStates}
          insuranceContactRef={insuranceContactRef}
          insuredCompany={insuredCompany}
          insuredCompanyType={insuredCompanyType}
          jointVentureType={jointVentureType}
          scrollToPosition={scrollToPosition}
        />
        <View
          insuredRenter={insuredRenter}
          insuredFirstName={insuredFirstName}
          insuredLastName={insuredLastName}
          insuredCompany={insuredCompany}
          insuredAddress={insuredAddress}
          insuredCity={insuredCity}
          insuredState={insuredState}
          insuredZip={insuredZip}
          insuredCountry={insuredCountry}
          show={confirmed}
        />
      </div>
    </div>
  </div>
);
Insured.propTypes = {
  edit: PropTypes.func.isRequired,
  confirm: PropTypes.func.isRequired,
  enabled: PropTypes.bool.isRequired,
  confirmed: PropTypes.bool.isRequired,
  insuredRenter: PropTypes.bool.isRequired,
  insuredFirstName: PropTypes.string.isRequired,
  insuredCompany: PropTypes.string.isRequired,
  insuredCompanyType: PropTypes.string.isRequired,
  jointVentureType: PropTypes.string.isRequired,
  insuredLastName: PropTypes.string.isRequired,
  insuredAddress: PropTypes.string.isRequired,
  insuredCity: PropTypes.string.isRequired,
  insuredState: PropTypes.string.isRequired,
  insuredZip: PropTypes.string.isRequired,
  insuredCountry: PropTypes.string.isRequired,
  valid: PropTypes.bool.isRequired,
  usStates: usStatePropType.isRequired,
  scrollToPosition: PropTypes.func.isRequired,
  insuranceContactRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]).isRequired,
};

export default Insured;
